export default "__VITE_ASSET__CHOskLWS__"